<template lang="pug">
  div.registry.operator-update
    router-view

    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка отходы
          // have differnt logic for some region
          div(v-if="tabView == 'tab8'")
            r-registry-operator-garbage-table(
            :id="fields.id"
            )

          // only for some regions
          div(v-if="tabView == 'transport' && $options.components['r-transport-table']")
            r-transport-table(
            :id="fields.id"
            :fields="fields"
            )


          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body.body-table.body-table--noBottomPadding
              div.table-choose-panel
                div.toolbar-table
                  div.toolbar.toolbar--modal.toolbar-extended
                    div.line
                      div(v-if="showSetUnsetRoBtn").additional-panel
                        e-button(
                        v-if="fields.is_regional===true"
                        @click="openUnsetRO()"
                        label="Снять статус Рег. оператора"
                        ).green.green--withText

                        e-button(
                        v-if="fields.is_regional!==true"
                        @click="openSetRO()"
                        label="Назначить рег. оператором"
                        ).green.green--withText


            e-modal(
            v-if="showModalSetRO"
            @close="cancelChangeStatus()"
            @confirm="setROStatus()"
            title="Добавление нового соглашения"
            :autoHeight="true"
            )
              slot
                div.body
                  div.col
                    e-form-group(
                    name="agreement_num"
                    inputType="input"
                    label="Соглашение №"
                    :model="fields"
                    :required="true"
                    tabView="tab1"
                    modalVariableName="showModalSetRO"
                    )
                    div.col-block
                      div.half-blocks
                        e-form-group(
                        name="agreement_from"
                        inputType="calendar"
                        formGroupStyle="half-block"
                        label="От"
                        :model="fields"
                        :required="true"
                        tabView="tab1"
                        modalVariableName="showModalSetRO"
                        )
                        e-form-group(
                        name="agreement_to"
                        inputType="calendar"
                        formGroupStyle="half-block"
                        label="До"
                        :model="fields"
                        :required="true"
                        tabView="tab1"
                        modalVariableName="showModalSetRO"
                        )


            e-modal(v-if="showModalRemoveROStatusConfirmation"
            @close="cancelChangeStatus()"
            @confirm="unsetROStatus()"
            :autoHeight="true"
            )
              slot
                div.body
                  div.col
                    div.col-block
                      div.info Снять статус регионального оператора с хозяйствующего субъекта? Вкладка "Зоны деятельности" и информация об Единном тарифе станут недоступны.

            div.body
              div.col
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование"
                :model="fields"
                tabView="tab1"
                :required="true"
                )
                e-form-group(
                name="short_name"
                inputType="input"
                label="Сокращенное наименование"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="ogrn"
                inputType="input"
                label="ОГРН/ОГРНИП"
                validationRule="number"
                :model="fields"
                tabView="tab1"
                :onChangeValidation="true"
                :onChangeValidationOptions="{disableAutoFocus: true}"
                :validationAdditionalRules="{specialValidate: validateOgrn}"
                )
                e-form-group(
                name="inn"
                inputType="input"
                label="ИНН"
                validationRule="number"
                :model="fields"
                tabView="tab1"
                :required="true"
                )
                e-form-group(
                name="kpp"
                inputType="input"
                label="КПП"
                validationRule="number"
                :model="fields"
                tabView="tab1"
                :onChangeValidation="true"
                :onChangeValidationOptions="{disableAutoFocus: true}"
                :validationAdditionalRules="{minLen: 9, maxLen: 9}"
                )
                e-form-group(
                name="legal_address"
                inputType="address"
                label="Юридический адрес"
                :model="fields"
                tabView="tab1"
                addressIdFieldName="legal_address_id"
                :addressData="addressData"
                )
                e-form-group(
                name="status_id"
                inputType="select"
                :required="true"
                label="Статус объекта"
                :model="fields"
                tabView="tab1"
                :options="statuses"
                )
                e-form-group(
                name="close_date"
                inputType="calendar"
                label="Дата закрытия"
                :model="fields"
                tabView="tab1"
                :disabled="fields.status_id !== notActive"
                )
              div.col
                e-form-subtitle(text="Вид деятельности по ОКВЭД")

                e-form-group(
                name="okved_old"
                inputType="input"
                label="ОКВЭД(номер)"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="okved_name_old"
                inputType="input"
                label="ОКВЭД(наименование)"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="business_category_id"
                inputType="select"
                label="Отношение к субъектам предпринимательства"
                :model="fields"
                tabView="tab1"
                :options="business_categories"
                )
                e-form-group(
                name="activity_description"
                inputType="textarea"
                label="Краткое описание деятельности"
                :model="fields"
                tabView="tab1"
                )

                e-form-subtitle(text="Руководитель")
                e-form-group(
                name="head_position"
                inputType="input"
                label="Должность"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_name"
                inputType="input"
                label="ФИО"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_phone"
                inputType="input"
                validationRule="phone"
                label="Телефон"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="head_email"
                inputType="input"
                validationRule="email"
                label="Email"
                :model="fields"
                tabView="tab1"
                )

              div.col
                e-form-subtitle(text="Местоположение")

                e-location(
                :formValidator="formValidator"
                :model="fields"
                name="fact_address"
                addressIdFieldName="fact_address_id"
                :required="true"
                :addressData="addressData"
                tabView="tab1"
                )
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="photoUploaded"
                  @fileRemoved="photoRemoved"
                  :showFilePreview="true"
                )

                e-form-subtitle(text="Ответственный за экологию")

                e-form-group(
                name="eco_position"
                inputType="input"
                label="Должность"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_name"
                inputType="input"
                label="ФИО"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_phone"
                inputType="input"
                label="Телефон"
                validationRule="phone"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="eco_email"
                inputType="input"
                validationRule="email"
                label="Email"
                :model="fields"
                tabView="tab1"
                )


          // вкладка ЛИЦЕНЗИЯ
          div(v-show="tabView == 'tab2'")
            div.body
              div.col
                e-form-group(
                name="license_number"
                inputType="input"
                label="Лицензия №"
                :model="fields"
                :required="true"
                tabView="tab2"
                )
                e-form-group(
                name="license_start_date"
                inputType="calendar"
                label="От"
                :required="true"
                :model="fields"
                tabView="tab2"
                )
                e-form-group(
                name="license_finish_date"
                inputType="calendar"
                label="До"
                :model="fields"
                tabView="tab2"
                :required="!fields.term"
                :disabled="fields.term"
                )
                div.col-block
                  //label
                  label.checked
                    input.checkbox(
                    type="checkbox"
                    v-model="fields.term"
                    )
                    span Бессрочная

              div.col
                div.col-block
                  e-form-group(
                  name="actions"
                  :model="fields"
                  label="Классы опасности по видам деятельности"
                  tabView="tab2"
                  :required="true"
                  )
                    slot
                      div.table
                        table
                          thead
                            th
                            th I
                            th II
                            th III
                            th IV
                          tbody
                            tr(
                            v-for="action in actionsTable"
                            )
                              td {{ action.desc }}
                              td
                                label.checked
                                  input.checkbox(type="checkbox" value="1" v-model="action.danger")
                                  span
                              td
                                label.checked
                                  input.checkbox(type="checkbox" value="2" v-model="action.danger")
                                  span
                              td
                                label.checked
                                  input.checkbox(type="checkbox" value="3" v-model="action.danger")
                                  span
                              td
                                label.checked
                                  input.checkbox(type="checkbox" value="4" v-model="action.danger")
                                  span

              div.col
                // uncomment for enable multiupoder
                //e-form-group(name="files" label="Лицензия" :model="fields" tabView="tab2")
                  slot
                    e-file-uploader(:entityId="$route.params.id" ref="fileUploader")
                e-form-group(
                name="filePreview"
                inputType="simple-file-uploader"
                label="Лицензия"
                :model="fields"
                tabView="tab2"
                :uploadUrl="uploadUrl"
                @fileUploaded="fileUploaded"
                @fileRemoved="fileRemoved"
                :showFilePreview="true"
                )

          // вкладка ЗОНЫ ДЕЙСТВИЯ
          div(v-show="tabView == 'tab3' && fields.is_regional==true")
            div.body.body-table
              div.table-choose-panel
                div.toolbar-table
                  div.toolbar.toolbar--modal.toolbar--extended
                    div.line
                      div.select Соглашение об организации деятельности по обращению с ТКО
                    div.line
                      e-form-group(
                      name="agreement_num"
                      inputType="input"
                      label="Соглашение №"
                      :model="fields"
                      :required="false"
                      tabView="tab3"
                      )
                      e-form-group(
                      name="agreement_from"
                      inputType="calendar"
                      label="От"
                      :model="fields"
                      :required="false"
                      tabView="tab3"
                      )
                      e-form-group(
                      name="agreement_to"
                      inputType="calendar"
                      label="Действует до"
                      :model="fields"
                      :required="fields.is_regional===true"
                      tabView="tab3"
                      )

                municipalities-with-zones(
                :fields="fields"
                tabView="tab3"
                )

          // ЗАКАЗЧИКИ
          div(v-show="tabView == 'tab4'")
            operator-customers(
            :fields="fields"
            @saved="innerUpdated"
            @delete="innerUpdated"
            )

          //ОБЪЕКТЫ ОБРАЩЕНИЯ
          div(v-show="tabView == 'tab5'")
            r-operator-objects-table(
            ref="operatorObjectsTable"
            :id="fields.id"
            :fields="fields"
            @saved="innerUpdated"
            @delete="innerUpdated"
            )

          // ТАРИФЫ
          tko-tariff(
          v-show="tabView == 'tab6'"
          :tkoOperatorTariffs="fields.tkoOperatorTariffs"
          ref="tkoTariff"
          :TARIFFS="TARIFFS"
          )

          //ИНВЕСТ ПРОГРАММА
          div(v-show="tabView == 'tab7'")
            div.body.body-table
              div.table-choose-panel
                div.toolbar-table
                  div.toolbar.toolbar--modal.toolbar--extended
                    div.line
                      e-form-group(
                      name="invest_num"
                      inputType="input"
                      validationRule="number"
                      label="Номер приказа"
                      :model="fields"
                      tabView="tab7"
                      )
                      e-form-group(
                      name="invest_from"
                      inputType="calendar"
                      label="От"
                      :model="fields"
                      tabView="tab7"
                      )
                      e-form-group(
                      name="invest_to"
                      inputType="calendar"
                      label="Действует до"
                      :model="fields"
                      tabView="tab7"
                      )
                      div.col-block.additional-panel
                        label
                        e-button(@click.prevent="changeInvestValidate() ? showModalSmallInvest = !showModalSmallInvest : ''" label="Сохранить").green.green--withText


                div.toolbar-table
                  div.select Финансирование инвестиционной программы, в тыс.руб
                  div.toolbar.toolbar--modal


                div.table#invest
                  table
                    thead
                      tr
                        th Источник финансирования
                        th(v-for="item, key in tkoOperatorInvestsByYear") {{item.year}}
                    tbody
                      tr
                        td Сумма собственных средств оператора
                        td(v-for="item, key in tkoOperatorInvestsByYear")
                          input(
                          @input="updateSummary(item)"
                          type="text"
                          v-model="item.self_resources"
                          )
                      tr
                        td Сумма средств бюджетов БС РФ
                        td(v-for="item, key in tkoOperatorInvestsByYear")
                          input(
                          @input="updateSummary(item)"
                          type="text"
                          v-model="item.gos_resources"
                          )
                      tr
                        td Всего средств
                        td(v-for="item, key in tkoOperatorInvestsByYear")
                          input(
                          v-e-element-rerender="updateSummary(item)"
                          type="text"
                          :disabled="true"
                          v-model="item.summary"
                          )

            e-modal(
            v-if="showModalSmallInvest"
            @close="showModalSmallInvest = false"
            @confirm="changeInvest()"
            :autoHeight="true"
            )
              slot
                div.body
                  div.col
                    div.col-block
                      div.info Изменение периода действия Инвестиционного Соглашения может повлиять на количество столбцов в таблице. Информация о финансировании может быть удалена. Сохранить новые реквизиты?


</template>

<script>
  import {tko, core} from '../../../api/api-endpoints.js'
  import operatorAllForm from '../mixins/operator-all-form.js'

  import OperatorCustomers from "../components/operator-customers"
  import MunicipalitiesWithZones from "../components/municipalities-with-zones"
  import TkoTariff from "../components/tko-tariff";

  export default {
    components: {TkoTariff, MunicipalitiesWithZones, OperatorCustomers},
    mixins: [operatorAllForm],
    data() {
      return {
        tabView: 'tab1',
        fields: {
          business_category_id: '',
          is_regional: false,
          coordinates: '0,0',
          latitude: '',
          longitude: '',
          mos: null
        },
        errors: null
      }
    },
    computed: {
      tabs () {
        const tabs = [
          {tab1: 'Общие сведения'}
        ]
        if (this.fields.is_regional === true) {
          tabs.push({tab3: 'Зоны действия'})
        }
        tabs.push({tab2: 'Лицензия'})
        tabs.push({tab6: 'Тарифы'})
        tabs.push({tab7: 'Инвестиционная программа'})
        tabs.push({tab4: 'Заказчики'})
        tabs.push({tab5: 'Объекты обращения'})
        tabs.push({tab8: 'Отходы'})
        if (this.$options.components['r-transport-table']) {
          tabs.push({transport: 'Автопарк'})
        }
        return tabs
      }
    },
    methods: {
      uploadUrl () {
        return core.file()
      },
      getBusinessCategoriesEndpoint(){
        return core.statuses({fields: 'business_category'})
      },
      getDeleteUrl(id){
        return tko.operatorDelete(id)
      },
      getUpdateOrCreateUrl() {
        return tko.operatorUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route){
        if (!route.params.id) {
          return null
        }
        return tko.operator(route.params.id)
      }
    }
  }
</script>
